<template>
  <div class="selettime-box" :class="isdisabled ? 'disabled' : ''">
    <div
      v-if="selectedValue"
      class="inpubox-wrap"
      @click="!isdisabled ? (isOpenTimePicker = !isOpenTimePicker) : () => {}"
    >
      <span class="inpubox">{{ selectedValue }}</span>

      <img
        class="arrow-icon"
        :class="isOpenTimePicker ? 'active' : ''"
        src="/media/images/icon/arrow-up-lg-icon.png"
        alt="selectboxarrow-down-icon.png"
      />
    </div>
    <!-- null일때 -->
    <div
      v-else-if="!selectedValue"
      class="inpubox-wrap"
      @click="!isdisabled ? (isOpenTimePicker = !isOpenTimePicker) : () => {}"
    >
      <span class="inpubox null"> 선택해주세요</span>
      <img
        class="arrow-icon"
        :class="isOpenTimePicker ? 'active' : ''"
        src="/media/images/icon/arrow-up-lg-icon.png"
        alt="selectboxarrow-down-icon.png"
      />
    </div>

    <ul v-click-outside="outSideClick" class="select-timepicker-wrap" v-if="isOpenTimePicker">
      <li class="select-timepicker-hour">
        <VueScrollPicker :options="hours" v-model="selectHour" @input="onHourChange" />
      </li>
      <li class="select-timepicker-min">
        <VueScrollPicker :options="minutes" v-model="selectMin" @input="onMinChange" />
      </li>
      <li class="select-timepicker-ampm">
        <VueScrollPicker :options="ampm" v-model="selectAmPm" @input="onAmPmChange" />
      </li>
    </ul>
  </div>
</template>
<script>
import { ScrollPicker } from 'vue-scroll-picker';
import vClickOutside from 'v-click-outside';
export default {
  props: {
    value: {
      type: String,
      default: null,
      required: false
    },
    isdisabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  emits: ['change-value'],
  components: {
    VueScrollPicker: ScrollPicker
  },
  data() {
    return {
      isOpenTimePicker: false,
      selectedValue: '',
      selectHour: 9,
      selectMin: 0,
      selectAmPm: 'AM',
      options: ['Apple', 'Banana', 'Cherry'],
      hours: Array.from({ length: 12 }, (_, index) => index + 1),
      minutes: Array.from({ length: 6 }, (_, index) => (index * 10 > 9 ? index * 10 : `0${index * 10}`)),
      ampm: [
        { name: 'AM', value: 'AM' },
        { name: 'PM', value: 'PM' }
      ]
    };
  },
  mounted() {
    this.setSelectTimeValue(this.value);
  },
  methods: {
    outSideClick() {
      this.isOpenTimePicker = false;
    },
    parseTime(timeStr) {
      if (timeStr) {
        const [hourStr, minuteStr] = timeStr.split(':');
        let hour = parseInt(hourStr, 10);
        const minute = parseInt(minuteStr, 10);
        let ampm = 'AM';

        if (hour === 0) {
          hour = 12;
          ampm = 'AM';
        } else if (hour < 12) {
          ampm = 'AM';
        } else if (hour === 12) {
          ampm = 'PM';
        } else {
          hour = hour - 12;
          ampm = 'PM';
        }

        return {
          hh: hour,
          mm: minute,
          ampm: ampm
        };
      }
      return null;
    },
    formatTime(hh, mm, ampm) {
      let hour = hh;

      if (ampm === 'AM') {
        if (hh === 12) {
          hour = 0;
        }
      } else if (ampm === 'PM') {
        if (hh !== 12) {
          hour = hh + 12;
        }
      }

      const hourStr = hour.toString().padStart(2, '0');
      const minuteStr = mm.toString().padStart(2, '0');

      return `${hourStr}:${minuteStr}`;
    },
    changeTime() {
      // HH,MM,AM/PM 으로 떨어지면 HH:MM 으로 바꾸기
      this.selectedValue = this.formatTime(this.selectHour, this.selectMin, this.selectAmPm);
      this.$emit('change-value', this.selectedValue);
    },
    onHourChange(value) {
      this.selectHour = value;
      this.changeTime();
    },
    onMinChange(value) {
      this.selectMin = value;
      this.changeTime();
    },
    onAmPmChange(value) {
      this.selectAmPm = value;
      this.changeTime();
    },
    setSelectTimeValue(val) {
      this.selectedValue = val;
      const timeValue = this.parseTime(this.selectedValue);
      if (timeValue) {
        const { hh, mm, ampm } = timeValue;
        this.selectHour = hh;
        this.selectMin = mm === 0 ? '00' : mm;
        this.selectAmPm = ampm;
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.setSelectTimeValue(val);
      } else {
        this.setSelectTimeValue(null);
      }
    }
  }
};
</script>
<style scoped src="@/assets/css/common/commonselecttime.css"></style>
